/**
 * Banner used on **Final turn recap** — there is no following turn to hand off to.
 */
export function ThatsTheLastTurnCard() {
  return (
    <div className="rounded-lg border border-border bg-background p-3 text-typ-ui shadow-sm">
      <p className="font-semibold text-foreground">That&apos;s the last turn</p>
    </div>
  );
}
